import axios from 'axios'
export default {
  methods: {
    data(){
      return {
        publicPath: process.env.BASE_URL
      }
    },
    getAllKaisoData (callback) {
      var self = this
      if (self.$store.getters.kaiso1tbl.length > 0) {
        callback(null)
        return
      }
      axios
        .get(`${process.env.BASE_URL}kaiso.json`)
        .then(res => {
          self.$store.dispatch('upKaiso1tbl', res.data.kaiso1tbl)
          self.$store.dispatch('upKaiso2tbl', res.data.kaiso2tbl)
          self.$store.dispatch('upKaiso3tbl', res.data.kaiso3tbl)
          self.$store.dispatch('upContent', res.data.contents)

          callback(null)
        })
        .catch(res => {
          callback(res)
        })
    }
  }
}
